import { SITE_CODE, type SiteCode } from '@olxpwa-lib/data-layer';

export const MAP_SITE_CODE_TO_LANDING_TIER_SECTION_URL: Record<SiteCode, string | null> = {
  [SITE_CODE.OLXPL]: 'https://profil-pracodawcy.olx.pl/#section-variants',
  [SITE_CODE.OLXRO]: 'https://profilul-companiei.olx.ro/#section-variants',
  [SITE_CODE.OLXBG]: null,
  [SITE_CODE.OLXKZ]: null,
  [SITE_CODE.OLXPT]: null,
  [SITE_CODE.OLXUA]: null,
  [SITE_CODE.OLXUZ]: null,
} as const;
